import {useEffect, useState} from 'react';
import {contentWidthWithHalfSky, desktopContentWidth} from 'app/styles/media';
import {LayoutMode} from 'app/styles/LayoutMode';

const getLayoutMode = (): LayoutMode => {
  if (window.matchMedia(`(min-width: ${contentWidthWithHalfSky}px)`).matches) {
    return LayoutMode.DesktopWithSky;
  }
  if (window.matchMedia(`(min-width: ${desktopContentWidth}px)`).matches) {
    return LayoutMode.DesktopNoSky;
  }
  return LayoutMode.Mobile;
};

const useLayoutMode = () => {
  const [mode, setMode] = useState<LayoutMode>(() =>
    typeof window === 'undefined' ? LayoutMode.Mobile : getLayoutMode()
  );

  useEffect(() => {
    const update = () => {
      const layout = getLayoutMode();
      setMode(layout);
    };

    update(); // in case initial render mismatch (hydration on desktop)
    window.addEventListener('resize', update);
    screen.orientation?.addEventListener('change', update);
    return () => {
      window.removeEventListener('resize', update);
      screen.orientation?.addEventListener('change', update);
    };
  }, []);

  return mode;
};

export {useLayoutMode};
